import React from 'react';

import type { Timeline } from '../../types/timeline';

const TimelineReactions: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  return (
    <div className="timeline-reactions wa-grid wa-gap-s">
      <div className="page-eyebrow with-separator">
        Reactions across this timeline
      </div>
      <div className="memory-reactions wa-cluster wa-gap-2xs">
        {timeline.reactions?.map((reaction) => (
          <wa-tag key={reaction.id}>
            <i className={`fa-solid fa-${reaction.icon}`}></i>
            {reaction.name} · {reaction.users_count}
          </wa-tag>
        ))}
        {timeline.reactions?.length === 0 && (
          <span className="memory-reactions-no-reactions">
            No reactions yet
          </span>
        )}
      </div>
    </div>
  );
}

export default TimelineReactions;
